import {
    CREATE_BOOKING_START,
    CREATE_BOOKING_SUCCESS,
    CREATE_BOOKING_ERROR
} from '../../constants';
import { change } from 'redux-form';
import { createUserBooking as mutation } from '../../lib/graphql/booking';
import showToaster from '../../helpers/toastrMessgaes/showToaster';


export function createBookingAction({ orderId, requestCurrency, reviewDescription, dropOffLocation, dropOffLat, dropOffLng, promoId, paymentType, preferredPartnerId }) {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: CREATE_BOOKING_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    orderId,
                    dropOffLocation,
                    dropOffLat,
                    dropOffLng,
                    requestCurrency,
                    promoId,
                    reviewDescription,
                    paymentType,
                    preferredPartnerId
                },
            });
            if (data?.createUserBooking?.status === 200) {
                dispatch({
                    type: CREATE_BOOKING_SUCCESS,
                });
                await dispatch(change("ConfirmBookingBanner", 'bookingId', data?.createUserBooking?.result?.id));
            } else {
                dispatch({
                    type: CREATE_BOOKING_ERROR,
                    payload: {
                        error: data?.createUserBooking?.errorMessage,
                    },
                });
                let errorMessage = data?.createUserBooking?.errorMessage;
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage })
            }
        } catch (error) {
            dispatch({
                type: CREATE_BOOKING_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}